import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import successIcon from '../../assets/my-tickets/checkmark.svg';
import infoIcon     from 'react-icons/lib/md/info';
import warningIcon  from 'react-icons/lib/fa/exclamation-triangle';
import dangerIcon   from 'react-icons/lib/fa/exclamation-circle';
import errorIcon    from 'react-icons/lib/fa/exclamation-circle';


import './index.css';

const icons = {
  success: successIcon,
  info: infoIcon,
  warning: warningIcon,
  danger: dangerIcon,
  error: errorIcon
};

type Props = {
  messages: Array;
  dismissMessage: Function;
};

const flashMessage = (msg, props) => {
  const Icon = icons[msg.level];
  return (
    <div
      key={`flash-message-${msg.id}`}
      className={`flash-message ${msg.level}`}
      onClick={props.dismissMessage.bind(this, msg.id)}
    >
      <Icon className="icon" />
      {msg.content}
    </div>
  );
};

const Flash = (props: Props) => (
  <div id="flash-messages">
    <ReactCSSTransitionGroup
      transitionName="flash"
      transitionEnterTimeout={200}
      transitionLeaveTimeout={200}
    >
      {props.messages.map(msg => {
        return flashMessage(msg, props);
      })}
    </ReactCSSTransitionGroup>
  </div>
);

export default Flash;



// WEBPACK FOOTER //
// ./src/components/flash/index.js